import {AbstractControl, ValidationErrors} from "@angular/forms";

export function containsSpecialCharacterValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value || /[!@#$%^&*(),.?":{}|<>]/.test(control.value)) {
    return null;
  }

  control.setErrors({containsSpecialCharacter: true});
  return {containsSpecialCharacter: true};
}
